import { render, staticRenderFns } from "./JsonEditor.vue?vue&type=template&id=1b5a31f9&scoped=true"
import script from "./JsonEditor.vue?vue&type=script&lang=js"
export * from "./JsonEditor.vue?vue&type=script&lang=js"
import style0 from "./JsonEditor.vue?vue&type=style&index=0&id=1b5a31f9&prod&scoped=true&lang=css"
import style1 from "./JsonEditor.vue?vue&type=style&index=1&id=1b5a31f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5a31f9",
  null
  
)

export default component.exports